<div class="map_box_div">    
    <div class="close-button-container" (click)="closeModal()" ngbTooltip="Fechar">&times;</div>
    <div class="map" id="map"></div>
</div>